@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import br.gov.go.pge.permanenciaweb.site.pages.Index as _br_gov_go_pge_permanenciaweb_site_pages_Index
import br.gov.go.pge.permanenciaweb.site.pages.Liberacoes as _br_gov_go_pge_permanenciaweb_site_pages_Liberacoes
import br.gov.go.pge.permanenciaweb.site.pages.Login as _br_gov_go_pge_permanenciaweb_site_pages_Login
import br.gov.go.pge.permanenciaweb.site.pages.SemAcesso as _br_gov_go_pge_permanenciaweb_site_pages_SemAcesso
import br.gov.go.pge.permanenciaweb.site.pages.admin.Usuarios as _br_gov_go_pge_permanenciaweb_site_pages_admin_Usuarios

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Permanência no Prédio"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _br_gov_go_pge_permanenciaweb_site_pages_Index()
        }
        ctx.router.register(
            "/admin/usuarios",
        ) { pageCtx -> 
            _br_gov_go_pge_permanenciaweb_site_pages_admin_Usuarios()
        }
        ctx.router.register(
            "/liberacoes",
        ) { pageCtx -> 
            _br_gov_go_pge_permanenciaweb_site_pages_Liberacoes()
        }
        ctx.router.register(
            "/login",
        ) { pageCtx -> 
            _br_gov_go_pge_permanenciaweb_site_pages_Login()
        }
        ctx.router.register(
            "/sem-acesso",
        ) { pageCtx -> 
            _br_gov_go_pge_permanenciaweb_site_pages_SemAcesso()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("roster-layout", br.gov.go.pge.permanenciaweb.site.components.RosterLayoutStyle)
        ctx.theme.registerStyle("table", br.gov.go.pge.permanenciaweb.site.components.TableStyle)
        ctx.theme.registerStyle("table-cell", br.gov.go.pge.permanenciaweb.site.components.TableCellStyle)
        ctx.theme.registerStyle("table-header-cell", br.gov.go.pge.permanenciaweb.site.components.TableHeaderCellStyle)
        ctx.theme.registerStyle("table-numeric-cell", br.gov.go.pge.permanenciaweb.site.components.TableNumericCellStyle)
        ctx.theme.registerStyle("table-numeric-header-cell", br.gov.go.pge.permanenciaweb.site.components.TableNumericHeaderCellStyle)
        ctx.theme.registerStyle("table-row-hover", br.gov.go.pge.permanenciaweb.site.components.TableRowHoverStyle)
        ctx.theme.registerStyle("table-scroll", br.gov.go.pge.permanenciaweb.site.components.TableScrollStyle)
        ctx.theme.registerStyle("alert-chip", br.gov.go.pge.permanenciaweb.site.components.AlertChipStyle)
        ctx.theme.registerStyle("sem-saida-dialog", br.gov.go.pge.permanenciaweb.site.components.SemSaidaDialogStyle)
        ctx.theme.registerStyle("sem-saida-dialog-title", br.gov.go.pge.permanenciaweb.site.components.SemSaidaDialogTitleStyle)
        ctx.theme.registerStyle("sem-saida-dialog-actions", br.gov.go.pge.permanenciaweb.site.components.SemSaidaDialogActionsStyle)
        ctx.theme.registerStyle("sem-saida-dialog-table", br.gov.go.pge.permanenciaweb.site.components.SemSaidaDialogTableStyle)
        ctx.theme.registerStyle("sortable-header-cell", br.gov.go.pge.permanenciaweb.site.components.SortableHeaderCellStyle)
        ctx.theme.registerStyle("sortable-numeric-header-cell", br.gov.go.pge.permanenciaweb.site.components.SortableNumericHeaderCellStyle)
        ctx.theme.registerStyle("column-sort-button", br.gov.go.pge.permanenciaweb.site.components.ColumnSortButtonStyle)
        ctx.theme.registerStyle("sort-indicator", br.gov.go.pge.permanenciaweb.site.components.SortIndicatorStyle)
        ctx.theme.registerStyle("sem-saida-view", br.gov.go.pge.permanenciaweb.site.components.SemSaidaViewStyle)
        ctx.theme.registerStyle("events-view", br.gov.go.pge.permanenciaweb.site.components.EventsViewStyle)
        ctx.theme.registerStyle("events-footer", br.gov.go.pge.permanenciaweb.site.components.EventsFooterStyle)
        ctx.theme.registerStyle("removed-list", br.gov.go.pge.permanenciaweb.site.components.RemovedListStyle)
        ctx.theme.registerStyle("removed-list-item", br.gov.go.pge.permanenciaweb.site.components.RemovedListItemStyle)
        ctx.theme.registerStyle("removed-note", br.gov.go.pge.permanenciaweb.site.components.RemovedNoteStyle)
        ctx.theme.registerStyle("toast", br.gov.go.pge.permanenciaweb.site.components.ToastStyle)
        ctx.theme.registerStyle("column-header", br.gov.go.pge.permanenciaweb.site.components.ColumnHeaderStyle)
        ctx.theme.registerStyle("column-header-label", br.gov.go.pge.permanenciaweb.site.components.ColumnHeaderLabelStyle)
        ctx.theme.registerStyle("column-filter-group", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterGroupStyle)
        ctx.theme.registerStyle("column-filter-trigger", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterTriggerStyle)
        ctx.theme.registerStyle("column-filter-count", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterCountStyle)
        ctx.theme.registerStyle("column-filter-popup", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterPopupStyle)
        ctx.theme.registerStyle("column-filter-actions", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterActionsStyle)
        ctx.theme.registerStyle("column-filter-input", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterInputStyle)
        ctx.theme.registerStyle("column-filter-search-row", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterSearchRowStyle)
        ctx.theme.registerStyle("column-filter-clear-button", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterClearButtonStyle)
        ctx.theme.registerStyle("select-all-row", br.gov.go.pge.permanenciaweb.site.components.SelectAllRowStyle)
        ctx.theme.registerStyle("column-filter-hint", br.gov.go.pge.permanenciaweb.site.components.ColumnFilterHintStyle)
        ctx.theme.registerStyle("filter-options", br.gov.go.pge.permanenciaweb.site.components.FilterOptionsStyle)
        ctx.theme.registerStyle("filter-empty", br.gov.go.pge.permanenciaweb.site.components.FilterEmptyStyle)
        ctx.theme.registerStyle("filter-options-separator", br.gov.go.pge.permanenciaweb.site.components.FilterOptionsSeparatorStyle)
        ctx.theme.registerStyle("confirm-dialog", br.gov.go.pge.permanenciaweb.site.components.ConfirmDialogStyle)
        ctx.theme.registerStyle("confirm-dialog-title", br.gov.go.pge.permanenciaweb.site.components.ConfirmDialogTitleStyle)
        ctx.theme.registerStyle("confirm-dialog-self-warning", br.gov.go.pge.permanenciaweb.site.components.ConfirmDialogSelfWarningStyle)
        ctx.theme.registerStyle("confirm-dialog-message", br.gov.go.pge.permanenciaweb.site.components.ConfirmDialogMessageStyle)
        ctx.theme.registerStyle("confirm-dialog-actions", br.gov.go.pge.permanenciaweb.site.components.ConfirmDialogActionsStyle)
        ctx.theme.registerStyle("panel", br.gov.go.pge.permanenciaweb.site.components.PanelStyle)
        ctx.theme.registerStyle("panel-title", br.gov.go.pge.permanenciaweb.site.components.PanelTitleStyle)
        ctx.theme.registerStyle("panel-empty", br.gov.go.pge.permanenciaweb.site.components.PanelEmptyStyle)
        ctx.theme.registerStyle("panel-header", br.gov.go.pge.permanenciaweb.site.components.PanelHeaderStyle)
        ctx.theme.registerStyle("panel-header-title", br.gov.go.pge.permanenciaweb.site.components.PanelHeaderTitleStyle)
        ctx.theme.registerStyle("collapsible-panel-title", br.gov.go.pge.permanenciaweb.site.components.CollapsiblePanelTitleStyle)
        ctx.theme.registerStyle("pagination", br.gov.go.pge.permanenciaweb.site.components.PaginationStyle)
        ctx.theme.registerStyle("pagination-compact", br.gov.go.pge.permanenciaweb.site.components.PaginationCompactStyle)
        ctx.theme.registerStyle("pagination-button", br.gov.go.pge.permanenciaweb.site.components.PaginationButtonStyle)
        ctx.theme.registerStyle("pagination-current", br.gov.go.pge.permanenciaweb.site.components.PaginationCurrentStyle)
        ctx.theme.registerStyle("pagination-ellipsis", br.gov.go.pge.permanenciaweb.site.components.PaginationEllipsisStyle)
        ctx.theme.registerStyle("kpi-card", br.gov.go.pge.permanenciaweb.site.components.KpiCardStyle)
        ctx.theme.registerStyle("kpi-label", br.gov.go.pge.permanenciaweb.site.components.KpiLabelStyle)
        ctx.theme.registerStyle("kpi-value", br.gov.go.pge.permanenciaweb.site.components.KpiValueStyle)
        ctx.theme.registerStyle("removal-dialog", br.gov.go.pge.permanenciaweb.site.components.RemovalDialogStyle)
        ctx.theme.registerStyle("removal-dialog-title", br.gov.go.pge.permanenciaweb.site.components.RemovalDialogTitleStyle)
        ctx.theme.registerStyle("removal-dialog-actions", br.gov.go.pge.permanenciaweb.site.components.RemovalDialogActionsStyle)
        ctx.theme.registerStyle("removal-dialog-note", br.gov.go.pge.permanenciaweb.site.components.RemovalDialogNoteStyle)
        ctx.theme.registerStyle("photo-dialog", br.gov.go.pge.permanenciaweb.site.components.PhotoDialogStyle)
        ctx.theme.registerStyle("photo-dialog-row", br.gov.go.pge.permanenciaweb.site.components.PhotoDialogRowStyle)
        ctx.theme.registerStyle("photo-card", br.gov.go.pge.permanenciaweb.site.components.PhotoCardStyle)
        ctx.theme.registerStyle("photo-frame", br.gov.go.pge.permanenciaweb.site.components.PhotoFrameStyle)
        ctx.theme.registerStyle("photo-placeholder", br.gov.go.pge.permanenciaweb.site.components.PhotoPlaceholderStyle)
        ctx.theme.registerStyle("photo-dialog-actions", br.gov.go.pge.permanenciaweb.site.components.PhotoDialogActionsStyle)
        ctx.theme.registerStyle("photo-card-title", br.gov.go.pge.permanenciaweb.site.components.PhotoCardTitleStyle)
        ctx.theme.registerStyle("photo-loading-bar", br.gov.go.pge.permanenciaweb.site.components.PhotoLoadingBarStyle)
        ctx.theme.registerStyle("photo-loading-segment", br.gov.go.pge.permanenciaweb.site.components.PhotoLoadingSegmentStyle)
        ctx.theme.registerStyle("caveat", br.gov.go.pge.permanenciaweb.site.components.CaveatStyle)
        ctx.theme.registerStyle("badge", br.gov.go.pge.permanenciaweb.site.components.BadgeStyle)
        ctx.theme.registerStyle("user-menu-popup", br.gov.go.pge.permanenciaweb.site.components.UserMenuPopupStyle)
        ctx.theme.registerStyle("user-menu-label", br.gov.go.pge.permanenciaweb.site.components.UserMenuLabelStyle)
        ctx.theme.registerStyle("user-menu-trigger-label", br.gov.go.pge.permanenciaweb.site.components.UserMenuTriggerLabelStyle)
        ctx.theme.registerStyle("user-menu-active-label", br.gov.go.pge.permanenciaweb.site.components.UserMenuActiveLabelStyle)
        ctx.theme.registerStyle("user-menu-item", br.gov.go.pge.permanenciaweb.site.components.UserMenuItemStyle)
        ctx.theme.registerStyle("user-menu-danger-item", br.gov.go.pge.permanenciaweb.site.components.UserMenuDangerItemStyle)
        ctx.theme.registerStyle("user-menu-trigger", br.gov.go.pge.permanenciaweb.site.components.UserMenuTriggerStyle)
        ctx.theme.registerStyle("user-menu-active-item", br.gov.go.pge.permanenciaweb.site.components.UserMenuActiveItemStyle)
        ctx.theme.registerStyle("user-menu-separator", br.gov.go.pge.permanenciaweb.site.components.UserMenuSeparatorStyle)
        ctx.theme.registerStyle("picker-card", br.gov.go.pge.permanenciaweb.site.components.PickerCardStyle)
        ctx.theme.registerStyle("picker-search", br.gov.go.pge.permanenciaweb.site.components.PickerSearchStyle)
        ctx.theme.registerStyle("picker-results", br.gov.go.pge.permanenciaweb.site.components.PickerResultsStyle)
        ctx.theme.registerStyle("picker-results-inner", br.gov.go.pge.permanenciaweb.site.components.PickerResultsInnerStyle)
        ctx.theme.registerStyle("picker-spinner", br.gov.go.pge.permanenciaweb.site.components.PickerSpinnerStyle)
        ctx.theme.registerStyle("picker-row", br.gov.go.pge.permanenciaweb.site.components.PickerRowStyle)
        ctx.theme.registerStyle("screen-reader-only", br.gov.go.pge.permanenciaweb.site.components.ScreenReaderOnlyStyle)
        ctx.theme.registerStyle("picker-muted", br.gov.go.pge.permanenciaweb.site.components.PickerMutedStyle)
        ctx.theme.registerStyle("picker-cell", br.gov.go.pge.permanenciaweb.site.components.PickerCellStyle)
        ctx.theme.registerStyle("date-picker-card", br.gov.go.pge.permanenciaweb.site.components.DatePickerCardStyle)
        ctx.theme.registerStyle("date-picker-month", br.gov.go.pge.permanenciaweb.site.components.DatePickerMonthStyle)
        ctx.theme.registerStyle("date-picker-grid", br.gov.go.pge.permanenciaweb.site.components.DatePickerGridStyle)
        ctx.theme.registerStyle("date-picker-weekday", br.gov.go.pge.permanenciaweb.site.components.DatePickerWeekdayStyle)
        ctx.theme.registerStyle("day", br.gov.go.pge.permanenciaweb.site.components.DayStyle)
        ctx.theme.registerStyle("stay-main", br.gov.go.pge.permanenciaweb.site.pages.StayMainStyle)
        ctx.theme.registerStyle("stay-field", br.gov.go.pge.permanenciaweb.site.pages.StayFieldStyle)
        ctx.theme.registerStyle("stay-hint", br.gov.go.pge.permanenciaweb.site.pages.StayHintStyle)
        ctx.theme.registerStyle("login-card", br.gov.go.pge.permanenciaweb.site.pages.LoginCardStyle)
        ctx.theme.registerStyle("login-hint", br.gov.go.pge.permanenciaweb.site.pages.LoginHintStyle)
        ctx.theme.registerStyle("login-form", br.gov.go.pge.permanenciaweb.site.pages.LoginFormStyle)
        ctx.theme.registerStyle("login-input", br.gov.go.pge.permanenciaweb.site.pages.LoginInputStyle)
        ctx.theme.registerStyle("login-message", br.gov.go.pge.permanenciaweb.site.pages.LoginMessageStyle)
        ctx.theme.registerStyle("access-editor", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorStyle)
        ctx.theme.registerStyle("access-editor-header", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorHeaderStyle)
        ctx.theme.registerStyle("access-editor-hint", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorHintStyle)
        ctx.theme.registerStyle("access-capability-desc", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessCapabilityDescStyle)
        ctx.theme.registerStyle("access-flag-text", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessFlagTextStyle)
        ctx.theme.registerStyle("access-section-title", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessSectionTitleStyle)
        ctx.theme.registerStyle("access-section-rule", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessSectionRuleStyle)
        ctx.theme.registerStyle("access-editor-body", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorBodyStyle)
        ctx.theme.registerStyle("access-editor-footer", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorFooterStyle)
        ctx.theme.registerStyle("access-editor-error", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorErrorStyle)
        ctx.theme.registerStyle("access-editor-danger", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessEditorDangerStyle)
        ctx.theme.registerStyle("access-danger-label", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessDangerLabelStyle)
        ctx.theme.registerStyle("access-history-row", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessHistoryRowStyle)
        ctx.theme.registerStyle("access-history-label", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessHistoryLabelStyle)
        ctx.theme.registerStyle("access-history-revoked", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessHistoryRevokedStyle)
        ctx.theme.registerStyle("access-summary", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessSummaryStyle)
        ctx.theme.registerStyle("admin-main", br.gov.go.pge.permanenciaweb.site.pages.admin.AdminMainStyle)
        ctx.theme.registerStyle("admin-hint", br.gov.go.pge.permanenciaweb.site.pages.admin.AdminHintStyle)
        ctx.theme.registerStyle("admin-name-hint", br.gov.go.pge.permanenciaweb.site.pages.admin.AdminNameHintStyle)
        ctx.theme.registerStyle("preset-select", br.gov.go.pge.permanenciaweb.site.pages.admin.PresetSelectStyle)
        ctx.theme.registerStyle("admin-search", br.gov.go.pge.permanenciaweb.site.pages.admin.AdminSearchStyle)
        ctx.theme.registerStyle("warning-banner", br.gov.go.pge.permanenciaweb.site.pages.admin.WarningBannerStyle)
        ctx.theme.registerStyle("access-chip", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessChipStyle)
        ctx.theme.registerStyle("sync-warning", br.gov.go.pge.permanenciaweb.site.pages.admin.SyncWarningStyle)
        ctx.theme.registerVariant("-alert-inconsistent", br.gov.go.pge.permanenciaweb.site.components.AlertInconsistentVariant)
        ctx.theme.registerVariant("-alert-released", br.gov.go.pge.permanenciaweb.site.components.AlertReleasedVariant)
        ctx.theme.registerVariant("-alert-expired", br.gov.go.pge.permanenciaweb.site.components.AlertExpiredVariant)
        ctx.theme.registerVariant("-alert-sem-saida", br.gov.go.pge.permanenciaweb.site.components.AlertSemSaidaVariant)
        ctx.theme.registerVariant("-alert-empty", br.gov.go.pge.permanenciaweb.site.components.AlertEmptyVariant)
        ctx.theme.registerVariant("-reentered-item", br.gov.go.pge.permanenciaweb.site.components.ReenteredItemVariant)
        ctx.theme.registerVariant("-visible", br.gov.go.pge.permanenciaweb.site.components.ToastVisibleVariant)
        ctx.theme.registerVariant("-danger", br.gov.go.pge.permanenciaweb.site.components.ToastDangerVariant)
        ctx.theme.registerVariant("-danger-visible", br.gov.go.pge.permanenciaweb.site.components.ToastDangerVisibleVariant)
        ctx.theme.registerVariant("-primary", br.gov.go.pge.permanenciaweb.site.components.PrimaryButtonVariant)
        ctx.theme.registerVariant("-danger", br.gov.go.pge.permanenciaweb.site.components.DangerButtonVariant)
        ctx.theme.registerVariant("-default", br.gov.go.pge.permanenciaweb.site.components.DefaultButtonVariant)
        ctx.theme.registerVariant("-link", br.gov.go.pge.permanenciaweb.site.components.LinkButtonVariant)
        ctx.theme.registerVariant("-active", br.gov.go.pge.permanenciaweb.site.components.KpiCardActiveVariant)
        ctx.theme.registerVariant("-steel", br.gov.go.pge.permanenciaweb.site.components.KpiValueSteelVariant)
        ctx.theme.registerVariant("-orange", br.gov.go.pge.permanenciaweb.site.components.KpiValueOrangeVariant)
        ctx.theme.registerVariant("-red", br.gov.go.pge.permanenciaweb.site.components.KpiValueRedVariant)
        ctx.theme.registerVariant("-online", br.gov.go.pge.permanenciaweb.site.components.BadgeOnlineVariant)
        ctx.theme.registerVariant("-offline", br.gov.go.pge.permanenciaweb.site.components.BadgeOfflineVariant)
        ctx.theme.registerVariant("-picker-pinned-row", br.gov.go.pge.permanenciaweb.site.components.PickerPinnedRowVariant)
        ctx.theme.registerVariant("-picker-clickable-row", br.gov.go.pge.permanenciaweb.site.components.PickerClickableRowVariant)
        ctx.theme.registerVariant("-person-row", br.gov.go.pge.permanenciaweb.site.components.PersonRowButtonVariant)
        ctx.theme.registerVariant("-date-picker-nav", br.gov.go.pge.permanenciaweb.site.components.DatePickerNavButtonVariant)
        ctx.theme.registerVariant("-selected", br.gov.go.pge.permanenciaweb.site.components.DaySelectedVariant)
        ctx.theme.registerVariant("-edge", br.gov.go.pge.permanenciaweb.site.components.DayEdgeVariant)
        ctx.theme.registerVariant("-disabled", br.gov.go.pge.permanenciaweb.site.components.DayDisabledVariant)
        ctx.theme.registerVariant("-login-error-box", br.gov.go.pge.permanenciaweb.site.pages.LoginErrorBoxVariant)
        ctx.theme.registerVariant("-login-info-box", br.gov.go.pge.permanenciaweb.site.pages.LoginInfoBoxVariant)
        ctx.theme.registerVariant("-danger", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessChipDangerVariant)
        ctx.theme.registerVariant("-warning", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessChipWarningVariant)
        ctx.theme.registerVariant("-muted", br.gov.go.pge.permanenciaweb.site.pages.admin.AccessChipMutedVariant)
        br.gov.go.pge.permanenciaweb.site.initIndustrialTheme(ctx)
        br.gov.go.pge.permanenciaweb.site.initGlobalStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        br.gov.go.pge.permanenciaweb.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
